import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallsAPI, HttpOptions } from './abstract/http/calls-api';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnboardingServiceService extends CallsAPI<any, any[]> {
  protected apiBasePath: string = environment.api_url;
  protected resourcePath: string = '';
  /**
   * Default Options per Request
   * @protected
   * @type {HttpOptions}
   * @memberof HttpApiService
   */
  protected override defaultOptions: HttpOptions = {
    withCredentials: true
  };

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public redeemToken(options?: HttpOptions): Observable<any> {
    return this.http.get<any>(this.buildAction('redeem'), this.buildOptions(options));
  }

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public updateProfile(body:any, options?: HttpOptions, ): Observable<any> {
    return this.http.post<any>(this.buildAction('redeem/submit'), body, this.buildOptions(options));
  }

}
